<template>
    <div>
        <div class="img_box">
            <img src="../../../common/images/gfbroker_01.jpg"/>
            <div class="content">
                <div class="content_text"><img src="../../../common/images/text.png"/></div>
                <div class="download_box clearfix">
                    <div class="btn_group">
                        <a :href="androidPackageUrl" class="btn_android" @click="androidClick()">
                            <img src="../../../common/images/btn_android.png"/>
                        </a>
                        <a href="javascript:void(0)" class="btn_ios" @click="iosClick()">
                            <img src="../../../common/images/btn_ios.png"/>
                        </a>
                    </div>
                    <div class="qrcode">
                        <img src="../../../common/images/broker_qrcode.png"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="img_box">
            <img src="../../../common/images/gfbroker_02.jpg"/>
            <img src="../../../common/images/gfbroker_03.jpg"/>
            <img src="../../../common/images/gfbroker_04.jpg"/>
        </div>
        <div class="foot_claim">本页数字仅作展示使用，不代表真实情况</div>


        <div class="fixed ios_download_tips" :style="{display: isShowIosTips ? 'block': 'none'}" id="ios_tips"
             @click.self="toggleShowIosTips()">
            <div class="tips_box">
                <div class="tips_header">
                    <div class="tips_title">下载提示</div>
                    <button type="button" class="tips_header_btn" @click.self="toggleShowIosTips()">X</button>
                </div>
                <div class="tips_content">
                    <p>请使用手机扫描二维码安装</p>
                </div>
                <div class="tips_btns">
                    <button type="button" class="tips_btn" @click="toggleShowIosTips()"><span>确定</span></button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import * as restApi from '../../../common/js/rest-api'
    import * as saService from '../../../common/js/sa-service'
    import {getDownloadUrl} from '../../../common/js/app-download-util'

    export default {


        data() {
            return {
                isShowIosTips: false,
                androidPackageUrl: '#'
            }
        },

        methods: {
            androidClick() {
                saService.trackButtonClick('official_web_android_download')
                saService.trackDownload('android')
            },
            iosClick() {
                saService.trackButtonClick('official_web_ios_tips')
                this.toggleShowIosTips()
            },
            toggleShowIosTips() {
                this.isShowIosTips = !this.isShowIosTips
            }
        },

        mounted: function () {
            restApi.getAppVersion({type: 'ANDROID'}).then(response => {
                this.androidPackageUrl = getDownloadUrl(response)
            })
        }

    }
</script>

<style lang="less">

    html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font: normal 100% inherit;
        vertical-align: baseline;
    }

    article, aside, details, figcaption, figure, footer, header, menu, nav, section {
        display: block;
    }

    body {
        line-height: 1;
        background: #fff;
        -moz-user-select: none;
        -khtml-user-select: none;
        user-select: none;
        font-family: "Helvetica Neue", "Hiragino Sans GB", "Segoe UI", "Microsoft Yahei", "微软雅黑", Tahoma, Arial, STHeiti, sans-serif;
    }

    html, body {
        -webkit-touch-callout: none;
    }

    ol, ul {
        list-style: none;
    }

    blockquote, q {
        quotes: none;
    }

    blockquote:before, blockquote:after, q:before, q:after {
        content: '';
        content: none;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    td {
        vertical-align: middle;
    }

    code {
        padding: 3px 6px;
        font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
        background: #fcfcfc;
        border: 1px solid #e4e4e4;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        color: #3f8faf;
    }

    /* Basic Alginment================================================== */
    img, object, video {
        height: auto;
        display: block;
        max-width: 100%;
    }

    img {
        width: auto;
        border: 0;
        -ms-interpolation-mode: bicubic;
    }

    /* #Typography================================================== */
    h1, h2, h3, h4, h5, h6 {
        color: #333;
        font-family: Arial, sans-serif;
        font-weight: bold;
    }

    h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
        font-weight: inherit;
    }

    h1 {
        font-size: 28px;
        line-height: 50px;
    }

    h2 {
        font-size: 22px;
        line-height: 30px;
    }

    h3 {
        font-size: 16px;
        line-height: 34px;
    }

    h4 {
        font-size: 14px;
        line-height: 30px;
    }

    h5 {
        font-size: 12px;
        line-height: 24px;
    }

    h6 {
        font-size: 10px;
        line-height: 21px;
    }

    p img {
        margin: 0;
    }

    p.lead {
        font-size: 21px;
        line-height: 27px;
        color: #777;
    }

    em {
        font-style: italic;
    }

    strong {
        font-weight: bold;
        color: #333;
    }

    small {
        font-size: 80%;
    }

    hr {
        border: solid #ddd;
        border-width: 1px 0 0;
        clear: both;
        margin: 10px 0 30px;
        height: 0;
    }

    /* #Links================================================== */
    a, img, button, input, textarea {
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    }

    a, a:visited {
        text-decoration: none;
        outline: 0;
        -webkit-transition: color 0.1s ease-in-out;
        -moz-transition: color 0.1s ease-in-out;
        -o-transition: color 0.1s ease-in-out;
        -transition: color 0.1s ease-in-out;
    }

    a:hover, a:focus {
        color: #333;
    }

    p a, p a:visited {
        line-height: inherit;
    }

    /* #Lists================================================== */
    ul, ol {
        margin: 0;
    }

    ul {
        list-style: none outside;
    }

    ol {
        list-style: decimal;
    }

    ol, ul.square, ul.circle, ul.disc {
        margin-left: 30px;
    }

    ul.square {
        list-style: square outside;
    }

    ul.circle {
        list-style: circle outside;
    }

    ul.disc {
        list-style: disc outside;
    }

    li {
        line-height: 18px;
    }

    ul.large li {
        line-height: 21px;
    }

    li p {
        line-height: 21px;
    }

    /* #Forms================================================== */
    fieldset {
        margin-bottom: 20px;
    }

    select {
        padding: 0;
        border-radius: 0;
    }

    textarea {
        min-height: 60px;
    }

    label, legend {
        display: block;
        font-weight: bold;
        font-size: 12px;
        font-weight: normal;
        margin-bottom: 8px;
    }

    input[type="checkbox"] {
        display: inline;
        top: 1px;
        position: relative;
        margin-right: 5px;
    }

    button, input, select, textarea {
        font-size: 100%;
        outline: none;
        box-sizing: inherit
    }

    input {
        outline: none;
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
        -webkit-user-modify: read-write-plaintext-only;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
        text-align: inherit
    }

    pre {
        white-space: pre-wrap
    }

    img {
        height: auto;
        max-width: 100%;
        vertical-align: middle;
        margin: 0;
    }

    button {
        cursor: pointer;
        border: none;
        padding: 0;
        margin: 0;
    }

    button, a, button:active, a:active {
        -webkit-tap-highlight-color: rgba(38, 133, 251, 0.5);
    }

    button[disabled] {
        background: #ddd;
        color: #888;
        border-color: #ddd
    }

    iframe {
        margin: 0;
        padding: 0
    }

    :active {
        -webkit-tap-highlight-color: rgba(38, 133, 251, 0.5);
    }

    .clearfix {
        clear: both;
    }

    .clearfix:after {
        clear: both;
        content: ' ';
        visibility: visible;
        display: block
    }

    .fixed {
        position: fixed !important;
    }

    /*html====================================*/
    body {
        max-width: 1920px;
        min-width: 960px;
        margin: 0 auto;
        overflow: auto;
    }

    .img_box {
        position: relative;
    }

    .content {
        text-align: right;
        width: 980px;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -490px;
        z-index: 2;
    }

    .content img {
        display: inline-block;
    }

    .content .content_text {
        padding-top: 70px
    }

    .content .download_box {
        margin-top: 20px
    }

    .content .qrcode {
        float: right;
        margin-right: 27px;
        width: 210px;
    }

    .content .btn_group {
        float: right
    }

    .btn_group a {
        display: block;
        width: 200px;
    }

    .btn_group .btn_ios {
        margin-top: 16px;
    }

    .ios_download_tips {
        background: rgba(0, 0, 0, 0.7);
        display: none;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        text-align: center;
        vertical-align: middle;
        z-index: 100;
        overflow: hidden
    }

    .tips_box {
        top: 50%;
        position: relative;
        margin-top: -82px;
        text-align: left;
        display: inline-block;
        vertical-align: middle;
        background-color: #fff;
        width: 420px;
        font-size: 16px;
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }

    .tips_box .tips_header {
        position: relative;
        padding: 20px 20px 0;
    }

    .tips_box .tips_title {
        padding-left: 0;
        margin-bottom: 0;
        font-size: 16px;
        font-weight: 700;
        height: 18px;
        color: #333;
    }

    .tips_box .tips_header_btn {
        color: #969696;
        position: absolute;
        top: 19px;
        right: 20px;
        background: transparent;
        border: none;
        outline: none;
        padding: 0;
        cursor: pointer;
    }

    .tips_box .tips_content {
        padding: 30px 20px;
        color: #48576a;
        font-size: 14px;
        position: relative;
    }

    .tips_box .tips_content p {
        margin: 0;
        line-height: 1.4;
    }

    .tips_box .tips_btns {
        padding: 10px 20px 15px;
        text-align: right;
    }

    .tips_box .tips_btns .tips_btn {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #20a0ff;
        border: 1px solid #20a0ff;
        color: #fff;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 0;
        -webkit-user-select: none;
        padding: 10px 15px;
        font-size: 14px;
    }

    @media screen and (max-width: 768px) {
        .tips_box {
            width: 300px;
        }

        .tips_box .tips_header {
            padding: 16px 16px 0;
        }

        .tips_box .tips_content {
            padding: 16px;
        }

        .tips_box .tips_btns {
            padding: 10px 16px 15px
        }

        .tips_box .tips_header_btn {
            right: 16px;
        }

    }

    @media screen and (max-width: 1280px) {
        .content {
            width: 600px;
            margin-left: -300px;
        }

        .content .content_text {
            padding-top: 40px
        }

        .content .content_text img {
            width: 450px
        }

        .content .download_box {
            margin-top: 15px
        }

        .content .qrcode {
            margin-right: 25px;
            width: 128px;
        }

        .btn_group a {
            display: block;
            width: 120px;
        }

        .btn_group .btn_ios {
            margin-top: 10px;
        }
    }

    @media screen and (min-width: 1280px) {
        .content {
            width: 780px;
            margin-left: -390px;
        }

        .content .content_text {
            padding-top: 50px
        }

        .content .content_text img {
            width: 600px
        }

        .content .download_box {
            margin-top: 20px
        }

        .content .qrcode {
            margin-right: 25px;
            width: 165px;
        }

        .btn_group a {
            display: block;
            width: 160px;
        }

    }

    @media screen and (min-width: 1440px) {
        .content {
            width: 880px;
            margin-left: -440px;
        }

        .content .content_text {
            padding-top: 54px
        }

        .content .content_text img {
            width: 680px
        }

        .content .download_box {
            margin-top: 20px
        }

        .content .qrcode {
            margin-right: 26px;
            width: 186px;
        }

        .btn_group a {
            display: block;
            width: 180px;
        }
    }

    @media screen and (min-width: 1600px) {
        .content {
            width: 980px;
            margin-left: -490px;
        }

        .content .content_text {
            padding-top: 70px
        }

        .content .content_text img {
            width: 750px
        }

        .content .download_box {
            margin-top: 25px
        }

        .content .qrcode {
            margin-right: 27px;
            width: 210px;
        }

        .btn_group a {
            display: block;
            width: 200px;
        }
    }

    @media screen and (min-width: 1920px) {
        .content {
            width: 1160px;
            margin-left: -580px;
        }

        .content .content_text {
            padding-top: 80px
        }

        .content .content_text img {
            width: 900px
        }

        .content .download_box {
            margin-top: 26px
        }

        .content .qrcode {
            margin-right: 28px;
            width: 244px;
        }

        .btn_group a {
            display: block;
            width: 238px;
        }
    }

    .foot_claim {
        padding: 15px;
        text-align: center;
        color: #969696;
        font-size: 14px;
    }


</style>



// WEBPACK FOOTER //
// src/pages/site/index/index.vue